import React, { useState } from "react";
import { Button, Col, Row, Modal, Image } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { NavLink, useHistory } from "react-router-dom";
import { HoursofItemAvailability } from "../../../../../../superAdminComponents/superAdminReusable/reusablePopupSuperAdmin/BusinessHoursMultiplePopup";
import PropTypes from "prop-types";
import { connect, useDispatch } from "react-redux";
import {
  delete_item_from_category,
  get_category_menu_setup,
} from "../../../../../../../store/actions/VendorSubscriptionAction/vendorSubscriptionGetAction";
import { delete_category_menu_setup } from "../../../../../../../store/actions/VendorSubscriptionAction/vendorSubscriptionPostAction";

import {
  SET_ACTIVE_CATEGORY_DATA_MENU_SETUP,
  SET_ACTIVE_ITEM_ID_MENU_SETUP,
  GET_VENDOR_MENU_CATEGORY_ITEMS,
} from "../../../../../../../store/types";
import Alert from "react-s-alert";

const MenuSetupItem = (props) => {
  //state

  const dispatch = useDispatch();
  let history = useHistory();

  const [state, setState] = useState({
    monday: {
      open: false,
      breakfast: {
        open: false,
        opening_time: new Date(2020, 1, 1, 10),
        closing_time: new Date(2020, 1, 1, 12),
      },
      lunch: {
        open: false,
        opening_time: new Date(2020, 1, 1, 13),
        closing_time: new Date(2020, 1, 1, 16),
      },
      dinner: {
        open: false,
        opening_time: new Date(2020, 1, 1, 19),
        closing_time: new Date(2020, 1, 1, 22),
      },
      multipleHours: [
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 10),
          closing_time: new Date(2020, 1, 1, 12),
          description: "Breakfast",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 16),
          description: "Lunch",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 19),
          closing_time: new Date(2020, 1, 1, 22),
          description: "Dinner",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 24),
          closing_time: new Date(2020, 1, 1, 4),
          description: "Midnight Munching",
        },
      ],
    },
    tuesday: {
      open: false,
      breakfast: {
        open: false,
        opening_time: new Date(2020, 1, 1, 8),
        closing_time: new Date(2020, 1, 1, 11),
      },
      lunch: {
        open: false,
        opening_time: new Date(2020, 1, 1, 13),
        closing_time: new Date(2020, 1, 1, 15),
      },
      dinner: {
        open: false,
        opening_time: new Date(2020, 1, 1, 17),
        closing_time: new Date(2020, 1, 1, 23),
      },
      multipleHours: [
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
          description: "Breakfast",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
          description: "Lunch",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
          description: "Dinner",
        },
      ],
    },
    wednesday: {
      open: false,
      breakfast: {
        open: false,
        opening_time: new Date(2020, 1, 1, 8),
        closing_time: new Date(2020, 1, 1, 11),
      },
      lunch: {
        open: false,
        opening_time: new Date(2020, 1, 1, 13),
        closing_time: new Date(2020, 1, 1, 15),
      },
      dinner: {
        open: false,
        opening_time: new Date(2020, 1, 1, 17),
        closing_time: new Date(2020, 1, 1, 23),
      },
      multipleHours: [
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
          description: "Breakfast",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
          description: "Lunch",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
          description: "Dinner",
        },
      ],
    },
    thursday: {
      open: false,
      breakfast: {
        open: false,
        opening_time: new Date(2020, 1, 1, 8),
        closing_time: new Date(2020, 1, 1, 11),
      },
      lunch: {
        open: false,
        opening_time: new Date(2020, 1, 1, 13),
        closing_time: new Date(2020, 1, 1, 15),
      },
      dinner: {
        open: false,
        opening_time: new Date(2020, 1, 1, 17),
        closing_time: new Date(2020, 1, 1, 23),
      },
      multipleHours: [
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
          description: "Breakfast",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
          description: "Lunch",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
          description: "Dinner",
        },
      ],
    },
    friday: {
      open: false,
      breakfast: {
        open: false,
        opening_time: new Date(2020, 1, 1, 8),
        closing_time: new Date(2020, 1, 1, 11),
      },
      lunch: {
        open: false,
        opening_time: new Date(2020, 1, 1, 13),
        closing_time: new Date(2020, 1, 1, 15),
      },
      dinner: {
        open: false,
        opening_time: new Date(2020, 1, 1, 17),
        closing_time: new Date(2020, 1, 1, 23),
      },
      multipleHours: [
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
          description: "Breakfast",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
          description: "Lunch",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
          description: "Dinner",
        },
      ],
    },
    saturday: {
      open: false,
      breakfast: {
        open: false,
        opening_time: new Date(2020, 1, 1, 8),
        closing_time: new Date(2020, 1, 1, 11),
      },
      lunch: {
        open: false,
        opening_time: new Date(2020, 1, 1, 13),
        closing_time: new Date(2020, 1, 1, 15),
      },
      dinner: {
        open: false,
        opening_time: new Date(2020, 1, 1, 17),
        closing_time: new Date(2020, 1, 1, 23),
      },
      multipleHours: [
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
          description: "Breakfast",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
          description: "Lunch",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
          description: "Dinner",
        },
      ],
    },
    sunday: {
      open: false,
      breakfast: {
        open: false,
        opening_time: new Date(2020, 1, 1, 8),
        closing_time: new Date(2020, 1, 1, 11),
      },
      lunch: {
        open: false,
        opening_time: new Date(2020, 1, 1, 13),
        closing_time: new Date(2020, 1, 1, 15),
      },
      dinner: {
        open: false,
        opening_time: new Date(2020, 1, 1, 17),
        closing_time: new Date(2020, 1, 1, 23),
      },
      multipleHours: [
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
          description: "Breakfast",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
          description: "Lunch",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
          description: "Dinner",
        },
      ],
    },
  });

  const [showItem, setShowItem] = useState(false);
  const handleShowItem = (id) => {
    setShowItem(!showItem);
    // const token = props.auth.user.accessToken;
    // props.get_all_items_from_category(id, token, onSuccess);
  };

  const takeToCategoryEditPage = (data) => {
    dispatch({ type: SET_ACTIVE_CATEGORY_DATA_MENU_SETUP, payload: data });
    history.push("/casual-fine-dining/menusetup/addcategory");
  };

  const takeToEditPage = (itemId) => {
    dispatch({ type: SET_ACTIVE_ITEM_ID_MENU_SETUP, payload: itemId });
    history.push("/casual-fine-dining/menusetup/additem");
  };

  const addNewItem = () => {
    dispatch({ type: SET_ACTIVE_ITEM_ID_MENU_SETUP, payload: "" });
    dispatch({ type: GET_VENDOR_MENU_CATEGORY_ITEMS, payload: [] });
    history.push("/casual-fine-dining/menusetup/additem");
  };

  const calcPrice = (item) => {
    let price = item.size && item.size[0] && item.size[0].price;
    return price;
  };
  return (
    <React.Fragment>
      <div className="enCategoryListOnboarding">
        <Row className="align-items-center">
          <Col md={5}>
            <div className="f16-500">
              Category : {props.category && props.category.name}
            </div>
            {/* <div className="f16-500">Category :</div> */}
          </Col>
          <Col
            md={7}
            className="d-flex flex-wrap align-items-center justify-content-end"
          >
            <button
              // to="/casual-fine-dining/menusetup/additem"
              className="btn-sm mr-2 btn btn-outline-secondary"
              onClick={() => addNewItem()}
            >
              Add Food Item
            </button>
            <button
              type="button"
              className="enBtnoutlineBlueIcon mr-2"
              onClick={() => takeToCategoryEditPage(props.category)}
            >
              <SVG
                src={require("../../../../../../../assets/images/UserManagement/pencil.svg")}
              />
            </button>
            <DeleteModal
              name="Category"
              categoryId={props.category && props.category._id}
              token={props.auth.user.accessToken}
              delete_category_menu_setup={props.delete_category_menu_setup}
              get_category_menu_setup={props.get_category_menu_setup}
            />

            <button
              type="button"
              className="btn btn-link ml-2"
              onClick={(e) => handleShowItem(props.category._id)}
            >
              <SVG
                src={
                  showItem
                    ? require("../../../../../../../assets/images/UserManagement/up-arrow-box.svg")
                    : require("../../../../../../../assets/images/UserManagement/down-arrow-box.svg")
                }
                width="20px"
                height="20px"
              />
            </button>
          </Col>
        </Row>
      </div>

      {showItem ? (
        <div className="enSubCategory top-border-merge">
          {props &&
            props.category &&
            props.category.items &&
            props.category.items.map((item, index) => (
              <Row className="align-items-center py-2" key={index}>
                <Col md={2}>
                  <div className="f12-500 text-break">ID {item._id}</div>
                </Col>
                <Col md={2}>
                  <div className="enIMG33 mt-2 rounded">
                    {item && item.images[0] ? (
                      <Image
                        //src={require("../../../../../../../assets/images/UserManagement/items.png")}
                        src={item.images[0]}
                        alt="Item image"
                        title="Item image"
                        fluid
                        width="100%"
                        height="100%"
                      />
                    ) : (
                      <Image
                        src={require("../../../../../../../assets/images/UserManagement/items.png")}
                        alt="Item image"
                        title="Item image"
                        fluid
                        width="100%"
                        height="100%"
                      />
                    )}
                  </div>
                </Col>
                <Col md={4}>
                  <div className="d-flex">
                    <SVG
                      width="16px"
                      height="18px"
                      src={
                        item.veg
                          ? require("../../../../../../../assets/images/UserManagement/veg.svg")
                          : require("../../../../../../../assets/images/UserManagement/nonveg.svg")
                      }
                    />
                    <div className="pl-2">
                      <div className="f12-500">{item.name}</div>
                      <div className="f11-400">{item.description}</div>
                    </div>
                  </div>
                </Col>
                {item.currentState !== 9 ? (
                  <Col md={4}>
                    <div className="btnf12_400_HelveticaNeue btn btn-outline-danger d-flex">
                      <span onClick={() => takeToEditPage(item._id)}>
                        Continue adding item &nbsp;
                      </span>
                      <i className="fa fa-arrow-right"></i>
                    </div>
                  </Col>
                ) : (
                  <>
                    <Col md={1}>
                      <div className="f12-500">
                        <span className="text-red mr-1">₹</span>
                        {calcPrice(item)}
                      </div>
                    </Col>
                    <Col md={3}>
                      <div className="d-flex">
                        <HoursofItemAvailability
                          id={item._id}
                          closed={false}
                          ItemName={item.name}
                          monday={
                            item.monday.open ? item.monday.multiple_timings : []
                          }
                          tuesday={
                            item.tuesday.open
                              ? item.tuesday.multiple_timings
                              : []
                          }
                          wednesday={
                            item.wednesday.open
                              ? item.wednesday.multiple_timings
                              : []
                          }
                          thursday={
                            item.thursday.open
                              ? item.thursday.multiple_timings
                              : []
                          }
                          friday={
                            item.saturday.open
                              ? item.friday.multiple_timings
                              : []
                          }
                          saturday={
                            item.open ? item.saturday.multiple_timings : []
                          }
                          sunday={
                            item.sunday.open ? item.sunday.multiple_timings : []
                          }
                        />
                        <button
                          className="editIcon-blue"
                          type="button"
                          onClick={() => takeToEditPage(item._id)}
                        >
                          <SVG
                            src={require("../../../../../../../assets/images/UserManagement/pencil.svg")}
                          />
                        </button>
                        {/* <button className="editIcon-grayBorder" type="button">
                    <SVG
                      src={require("../../../../../../../assets/images/UserManagement/Delete.svg")}
                    />
                  </button> */}
                        <DeleteItem
                          name={"item"}
                          id={item._id}
                          auth={props.auth}
                          delete_item_from_category={
                            props.delete_item_from_category
                          }
                          get_category_menu_setup={
                            props.get_category_menu_setup
                          }
                        />
                      </div>
                    </Col>
                  </>
                )}
              </Row>
            ))}

          {/* <Row className="align-items-center py-2">
            <Col md={2}>
              <div className="f12-500">ID 124532</div>
            </Col>
            <Col md={2}>
              <div className="enIMG33 mt-2 rounded">
                <Image
                  src={require("../../../../../../../assets/images/UserManagement/items.png")}
                  alt="View"
                  title="View"
                  fluid
                  width="100%"
                  height="100%"
                />
              </div>
            </Col>
            <Col md={4}>
              <div className="d-flex">
                <SVG
                  width="16px"
                  height="18px"
                  src={require("../../../../../../../assets/images/UserManagement/nonveg.svg")}
                />
                <div className="pl-2">
                  <div className="f12-500">Mozzarella Pizza</div>
                  <div className="f11-400">
                    Rich and creamy. Yet, light and fluffy
                  </div>
                </div>
              </div>
            </Col>
            <Col md={1}>
              <div className="f12-500">
                <span className="text-red mr-1">₹</span>250
              </div>
            </Col>
            <Col md={3}>
              <div className="d-flex">
                <HoursofItemAvailability
                  id={"ID124563"}
                  closed={false}
                  ItemName={"Item Name"}
                  monday={state.monday.multipleHours}
                  tuesday={state.tuesday.multipleHours}
                  wednesday={state.wednesday.multipleHours}
                  thursday={state.thursday.multipleHours}
                  friday={state.friday.multipleHours}
                  saturday={state.saturday.multipleHours}
                  sunday={state.sunday.multipleHours}
                />
                <button className="editIcon-blue" type="button">
                  <SVG
                    src={require("../../../../../../../assets/images/UserManagement/pencil.svg")}
                  />
                </button>
                <button className="editIcon-grayBorder" type="button">
                  <SVG
                    src={require("../../../../../../../assets/images/UserManagement/Delete.svg")}
                  />
                </button>
              </div>
            </Col>
          </Row> */}
        </div>
      ) : null}
    </React.Fragment>
  );
};
export const DeleteModal = (props) => {
  const [showBlockUser, seShowBlockUser] = useState(false);
  const handleCloseBlockUser = () => seShowBlockUser(false);
  const handleShowBlockUser = () => seShowBlockUser(true);

  const onSuccess = () => {
    props.get_category_menu_setup(props.token);
    seShowBlockUser(false);
  };

  const onClickDeleteCategory = () => {
    props.delete_category_menu_setup(props.categoryId, props.token, onSuccess);
  };

  return (
    <React.Fragment>
      {props.redButton ? (
        <div className="enIconBtn mr-3" onClick={handleShowBlockUser}>
          <Image
            src={require("../../../../../../../assets/images/UserManagement/Delete.svg")}
            alt="Delete item"
            title="Delete item"
            fluid
          />
        </div>
      ) : (
        <button
          type="button"
          className="enBtnoutlineGrayIcon"
          onClick={handleShowBlockUser}
        >
          <SVG
            src={require("../../../../../../../assets/images/UserManagement/Delete.svg")}
          />
        </button>
      )}
      <Modal show={showBlockUser} onHide={handleCloseBlockUser} centered>
        <Modal.Header className="py-0 pt-2 border-0" closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body className="f16-500">
          Are you sure to Delete this {props.name} ?
        </Modal.Body>
        <Modal.Footer className="justify-content-start border-0">
          <Button
            variant="outline-secondary"
            className="btn-lg mr-4 px-5"
            onClick={handleCloseBlockUser}
          >
            No
          </Button>
          <Button
            variant="danger"
            className="btn-lg px-5"
            // onClick={handleCloseBlockUser}
            onClick={() => onClickDeleteCategory()}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export const DeleteItem = (props) => {
  const [deleteItem, setDeleteItem] = useState(false);
  const handleDeleteItem = () => setDeleteItem(false);
  const onClickDeleteItem = () => setDeleteItem(true);
  const onClickYesDeleteItem = () => {
    const token = props.auth.user.accessToken;

    props.delete_item_from_category(props.id, token, onSuccess);
  };

  const onSuccess = () => {
    const token = props.auth.user.accessToken;
    props.get_category_menu_setup(token);
    Alert.success(`<h4>Item deleted sucessfully</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
  };

  return (
    <React.Fragment>
      <div
        className="editIcon-grayBorder cursor mr-3"
        onClick={onClickDeleteItem}
      >
        <Image
          src={require("../../../../../../../assets/images/UserManagement/Delete.svg")}
          alt="Delete item"
          title="Delete item"
          fluid
        />
      </div>

      <Modal show={deleteItem} onHide={handleDeleteItem} centered>
        <Modal.Header className="py-0 pt-2 border-0" closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body className="f16-500">
          Are you sure to Delete the {props.name} ?
        </Modal.Body>
        <Modal.Footer className="justify-content-start border-0">
          <Button
            variant="outline-secondary"
            className="btn-lg mr-4 px-5"
            onClick={handleDeleteItem}
          >
            No
          </Button>
          <Button
            variant="danger"
            className="btn-lg px-5"
            onClick={onClickYesDeleteItem}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

MenuSetupItem.propTypes = {
  auth: PropTypes.object.isRequired,
  //get_all_items_from_category: PropTypes.func.isRequired,
  delete_item_from_category: PropTypes.func.isRequired,
  get_category_menu_setup: PropTypes.func.isRequired,
  delete_category_menu_setup: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  menuCategoryItems: state.onboarding.menuCategoryItems,
});

export default connect(mapStateToProps, {
  delete_item_from_category,
  get_category_menu_setup,
  delete_category_menu_setup,
})(MenuSetupItem);
